export default __webpack_public_path__ + "5f961bf418e21b3e2aa54f02b0d17f8f.jpg";